import { Dialog, DialogContent, Divider } from "@mui/material"
import type { FC } from "react"
import React from "react"

import DialogHeader from "@/components/common/Modals/DialogHeader"
import type { GoodsReceiptPallet } from "@/graphql/codegen/graphql"
import { useAppView } from "@/hooks/useAppView"
import { PalletDestinationDisplay } from "@/screens/WarehouseReceiving/components/PalletComponents/PalletDestinationDisplay"
import { PalletInfoHeader } from "@/screens/WarehouseReceiving/components/PalletComponents/PalletInfoHeader"
import { PutAwayModalActions } from "@/screens/WarehouseReceiving/components/PalletComponents/PutAwayModalActions"

interface ManualPutAwayModalProps {
  pallet: GoodsReceiptPallet
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
}

export const ManualPutAwayModal: FC<ManualPutAwayModalProps> = ({ pallet, onClose, onConfirm, loading = false }) => {
  const { isTabletView } = useAppView()

  const destination = pallet.destinationWarehouseShelving
  const productName = pallet.goodsReceiptPalletRow?.product?.companyProductDescription || "Unknown Product"

  return (
    <Dialog
      open
      onClose={onClose}
      fullScreen={isTabletView}
      maxWidth='sm'
      fullWidth
      data-testid='manual-put-away-modal'
    >
      <DialogHeader title='Put Away' onClose={onClose} />

      <DialogContent className='p-10'>
        <PalletInfoHeader productName={productName} referenceId={pallet.referenceId} />
        <PalletDestinationDisplay destination={destination} />
      </DialogContent>
      <Divider />
      <PutAwayModalActions onCancel={onClose} onConfirm={onConfirm} loading={loading} />
    </Dialog>
  )
}
